<template>
  <div class="root-iframe">
    <iframe
      ref="iframe"
      width="100%"
      height="100%"
      :src="signal.resUrl"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
// 接口
import { ApiMethods } from "../assets/js/http-serve/http-methods";
export default {
  data() {
    return {
      smartAPI: ApiMethods.AIDocSmart,
      signal: "",
      timer: "",
      completeParams: {}
    };
  },
  created() {
    const draftId = JSON.parse(decodeURIComponent(this.$route.query.key));
    // 先获取通信参数
    this.smartAPI.draftInfo({ draftId }).then(res => {
      if (res.success) {
        this.signal = res.data;
      } else {
        this.$message.error(res.description);
      }
    });
  },
  mounted() {
    this.$refs.iframe.onload = () => {
      this.communication();
    };
  },
  methods: {
    // 完成合同起草
    endOfContract(data) {
      const draftId = JSON.parse(decodeURIComponent(this.$route.query.key));
      const parm = {
        draftId,
        fggId: data.id,
        fggKey: data.key
      };
      this.smartAPI.draftComplete(parm).then(res => {
        if (res.success) {
          window.close();
        } else {
          this.$message.error(res.description);
        }
      });
    },
    // 查询完成状态
    superContract() {
      const draftId = JSON.parse(decodeURIComponent(this.$route.query.key));
      this.smartAPI.draftCheck({ draftId }).then(res => {
        if (res.success) {
          // end 说明能够完成起草
          const { data } = res;
          this.signal.fggStatus = data.status;
          this.signal.num = data.num;
          setTimeout(() => {
            // 这里将状态改回来是为了不会一直提示未完成
            this.signal.fggStatus = "pending";
            this.signal.num = null;
          }, 1000);
        } else {
          this.$message.error(res.description);
        }
      });
    },
    // iframe 通信
    communication() {
      this.timer = setInterval(() => {
        const { signal } = this;
        // 1.确立通信源，origin是嵌入方的源地址，后面的*可以使用法狗狗地址https://products.fagougou.com或http://test.products.fagougou.com
        this.$refs["iframe"].contentWindow.postMessage(
          {
            draftId: this.$route.query.key,
            origin: window.location.origin,
            status: signal.fggStatus, // 必须参数
            userId: signal.fggUserId, // 必须参数
            userName: signal.fggUserName, // 必须参数
            userFlag: signal.fggUserFlag // 必须参数 super/admin
          },
          "https://products.fagougou.com"
        );
      }, 1000);

      // 2.监听审查或者起草的状态，法狗狗会返回相应状态数据
      window.addEventListener("message", ({ data }) => {
        console.log("e--", data);
        let { status, userFlag } = data;
        if (userFlag === "super") {
          //* 发起者(先查询能否完成)
          if (status === "complete") {
            if (!this.signal.FDDId) this.signal.FDDId = data.id;
            this.superContract(data);
          } else if (status === "end") {
            // 发起者再次通信后若能完成再走完成接口
            this.endOfContract({ id: this.signal.FDDId, ...data });
          }
        } else if (status === "complete" && userFlag === "admin") {
          //* 受邀者 (直接走完成接口)
          this.endOfContract(data);
        }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.indexOf("/smartDoc") >= 0) {
      window.sessionStorage.setItem("routeForm", from.path);
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    let routeForm = window.sessionStorage.getItem("routeForm");
    if (to.path.indexOf("/smartDoc") >= 0) {
      next();
    } else {
      // 跳转到列表业
      next({ path: routeForm });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped lang="less">
.root-iframe {
  height: 85vh;
}
</style>



// WEBPACK FOOTER //
// pages/iframbox.vue